import { API } from '../api';
import axiosInstance from '../axiosConfig';

export const getApiLogs = async () => {
  const response = await axiosInstance.get(API.API_LOGS.GET_LOGS);
  return response;
};
